import { alpha } from '@mui/material/styles';

// SLIGHTLY DARKER LIGHT THEME COLORS
const GREY = {
  0: "#FFFFFF",
  100: "#F7F8FA",
  200: "#EEF0F3",
  300: "#E0E3EA",
  400: "#C7CBD1",
  500: "#A6ADB6",
  600: "#868E97",
  700: "#646D7A",
  800: "#454F5B",
  900: "#2F3742",
};

const PRIMARY = {
  lighter: "#D6E9FF",
  light: "#8CBFFF",
  main: "#4285F4", // Soft but vivid blue
  dark: "#2564B6",
  darker: "#123B73",
  contrastText: GREY[0],
};

const SECONDARY = {
  lighter: "#FFF3DD",
  light: "#FFE0B2",
  main: "#FF9800", // Warm golden orange
  dark: "#CC7A00",
  darker: "#994F00",
  contrastText: GREY[900],
};

const INFO = {
  lighter: "#DAF3FE",
  light: "#82D4F9",
  main: "#29A9F4", // Crisp blue for information
  dark: "#1978B9",
  darker: "#0C4772",
  contrastText: GREY[0],
};

const SUCCESS = {
  lighter: "#DCF8E1",
  light: "#9FDBA6",
  main: "#4CAF50", // Vibrant but natural green
  dark: "#357A39",
  darker: "#1E4B23",
  contrastText: GREY[0],
};

const WARNING = {
  lighter: "#FFEDD4",
  light: "#FFD69B",
  main: "#FF9800", // Bold orange for warning
  dark: "#CC7700",
  darker: "#995900",
  contrastText: GREY[900],
};

const ERROR = {
  lighter: "#FFE5E5",
  light: "#FFB3B3",
  main: "#E57373", // Soft yet strong red
  dark: "#B75454",
  darker: "#7A3535",
  contrastText: GREY[0],
};

const palette = {
  common: { black: '#000', white: '#fff' },
  primary: PRIMARY,
  secondary: SECONDARY,
  info: INFO,
  success: SUCCESS,
  warning: WARNING,
  error: ERROR,
  grey: GREY,
  divider: alpha(GREY[400], 0.2),
  text: {
    primary: GREY[900],
    secondary: GREY[700],
    disabled: GREY[600],
  },
  background: {
    paper: GREY[200],
    default: GREY[100],
    neutral: GREY[300],
  },
  action: {
    active: GREY[700],
    hover: alpha(GREY[700], 0.08),
    selected: alpha(GREY[700], 0.16),
    disabled: alpha(GREY[700], 0.8),
    disabledBackground: alpha(GREY[700], 0.24),
    focus: alpha(GREY[700], 0.24),
    hoverOpacity: 0.08,
    disabledOpacity: 0.48,
  },
};

export default palette;
